module.exports = __webpack_public_path__ + "media/zoom4.a9e88160.wav";